import { createMessage } from "./asyncThunks";

export const createMessageBuilder = (builder) => {
  builder.addCase(createMessage.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(createMessage.fulfilled, (state) => {
    state.loading = false;
  });
  builder.addCase(createMessage.rejected, (state) => {
    state.loading = false;
  });
};
